/**
 * @file paddle pilot banner
 * @author wanzhongyun
 */

import React, { useEffect } from 'react';
import { Carousel } from 'antd';
import { IPilotBanner } from './../../type';

import './style.less';

const PilotBanner: React.FC<IPilotBanner> = props => {
    const { bannerList } = props;

    useEffect(() => {
        const bannerCardList = Array.from(document.querySelectorAll('.banner-card')) as HTMLDivElement[];
        const contentWrapperList = Array.from(
            document.querySelectorAll('.banner-card-content-wrapper')
        ) as HTMLDivElement[];
        const contentBtnLinkList = Array.from(document.querySelectorAll('.content-btn-link')) as HTMLDivElement[];
        if (bannerCardList && contentWrapperList && bannerCardList.length > 0) {
            bannerCardList.forEach((item, index) => {
                item.style.backgroundColor = bannerList[index].backgroundColor;
                contentBtnLinkList[index].style.borderColor = bannerList[index].color;
                contentBtnLinkList[index].style.color = bannerList[index].color;
            });
            contentWrapperList.forEach((item, index) => {
                item.style.color = bannerList[index].color;
            });
        }
    }, [bannerList]);

    return (
        <div className="paddle-pilot-banner-wrapper">
            <Carousel effect="fade" autoplay>
                {bannerList.map(item => (
                    <div className="banner-card" key={item.title + item.btnLink}>
                        <img className="banner-card-image" src={item.backgroundImageUrl} alt={item.title} />
                        <div className="banner-card-content-wrapper" style={{}}>
                            <div className="content-title">{item.title}</div>
                            <div className="content-desc">{item.desc}</div>
                            <a className="banner-card-link" href={item.btnLink} target="_blank" rel="noreferrer">
                                <div className="content-btn-link">{item.btnWord}</div>
                            </a>
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default PilotBanner;
